import update from 'immutability-helper';

import * as ObjectConst from '../constants/Property';
import * as ActionTypes from '../constants/ActionTypes';

const initialState = () => ({
    currentDays: [],
    currentDaysCurrency: undefined,
    mainPhotoURL: '',
    isRedirect: false,
    isShowProgressBar: false,
    isNeedCreateObject: false,
    isShowCalendarLoading: false,
    isRedirectToObjectPage: false,
    createdObject: {
        meta: {
            images: [],
            externalCalendars: []
        },
        props: {},
        price: {},
        other: {},
        location: {},
        amenities: [],
        description: {},
        userAddress: {},
        characteristics: {}
    },
    validation: {
        isPricesValid: false,
        isAddressValid: false,
        isGeneralInformationValid: false,
        isOtherValid: false
    },
    progressBarInfo: {
        loaded: 0,
        total: 1
    }
});

export default (state = initialState(), action) => {
    let meta;
    let index;
    let images;
    let _export;
    let validation;
    let currentDays;
    let userAddress;
    let createdObject;
    let isPricesValid;
    let externalCalendars;

    switch (action.type) {
        case ActionTypes.CREATING_OBJECT:
            return {...state, isRedirect: true, createdObject: action.payload};
        case ActionTypes.SET_REDIRECT:
            return {...state, isRedirect: action.payload};
        case ActionTypes.GET_CREATED_OBJECT:
            createdObject = action.payload;

            let isGeneralInformationValid = true;
            if (createdObject.description.description.length < 500) isGeneralInformationValid = false;
            if (createdObject.description.displayName.length > 100) isGeneralInformationValid = false;
            if (createdObject.props.countGuest < 1) isGeneralInformationValid = false;
            if (createdObject.props.area < 1) isGeneralInformationValid = false;
            if (createdObject.props.countBeds < 1) isGeneralInformationValid = false;
            if (createdObject.props.countBedrooms < 1) isGeneralInformationValid = false;
            if (createdObject.props.countBathrooms < 1) isGeneralInformationValid = false;

            let isAddressValid = true;
            userAddress = createdObject.userAddress;
            if (userAddress.city === null || userAddress.city.length === 0) isAddressValid = false;
            if (userAddress.index === null || userAddress.index.length === 0) isAddressValid = false;
            if (userAddress.street === null || userAddress.street.length === 0) isAddressValid = false;
            if (userAddress.country === null || userAddress.country.length === 0) isAddressValid = false;
            if (userAddress.province === null || userAddress.province.length === 0) isAddressValid = false;
            if (userAddress.streetNum === null || userAddress.streetNum.length === 0) isAddressValid = false;

            isPricesValid = true;
            const price = createdObject.price;
            if (createdObject.props.type === ObjectConst.TYPE.RENT) {
                if (price.priceRentBase === 0 || price.priceRentBase === '0') isPricesValid = false;
                if (createdObject.props.typeTerm === ObjectConst.TYPE_TERM.LONG) {
                    if (price.priceRentLong === 0 || price.priceRentLong === '0') isPricesValid = false;
                }
            } else {
                if (price.priceSell === 0 || price.priceSell === '0') isPricesValid = false;
            }
            let isOtherValid = true;
            if (createdObject.price.minDays < 1 || createdObject.props.license.length === 0 || createdObject.price.maxStay < 1) {
                isOtherValid = false;
            }

            validation = update(state.validation, {
                isPricesValid: {$set: isPricesValid},
                isAddressValid: {$set: isAddressValid},
                isGeneralInformationValid: {$set: isGeneralInformationValid},
                isOtherValid: {$set: isOtherValid},
            });

            return {...state, createdObject: createdObject, validation: validation};
        case ActionTypes.UPDATE_FIELD:
            createdObject = state.createdObject;
            const representField = ObjectConst.OBJECT_REPRESENT_FIELDS[action.payload.name];

            if (representField.parent === null) {
                if (representField == ObjectConst.OBJECT_REPRESENT_FIELDS.AMENITIES) {
                    createdObject = update(createdObject, {
                        [representField.value]: {$set: action.payload.value.split(",")}
                    });
                }
            } else {
                const parentObject = update(createdObject[representField.parent], {
                    [representField.value]: {$set: action.payload.value}
                });

                createdObject = update(createdObject, {
                    [representField.parent]: {$set: parentObject}
                });
            }

            // при изменении типа может измениться валидность полей
            isPricesValid = state.validation.isPricesValid;
            if (action.payload.name === ObjectConst.FIELDS.TYPE) {
                const price = createdObject.price;
                if (action.payload.value === ObjectConst.TYPE.RENT) {
                    if (price.priceRentBase === 0 || price.priceRentBase === '0') isPricesValid = false;
                    if (createdObject.props.typeTerm === ObjectConst.TYPE_TERM.LONG) {
                        if (price.priceRentLong === 0 || price.priceRentLong === '0') isPricesValid = false;
                    }
                } else {
                    if (price.priceSell === 0 || price.priceSell === '0') isPricesValid = false;
                }
            }
            validation = update(state.validation, {
                isPricesValid: {$set: isPricesValid}
            });

            return {...state, createdObject: createdObject, validation: validation};
        case ActionTypes.DELETE_IMAGE:
            createdObject = state.createdObject;
            index = createdObject.meta.images.findIndex(elem => elem.id === action.payload);

            images = update(createdObject.meta.images, {
                $splice: [[index, 1]]
            });
            meta = update(createdObject.meta, {
                images: {$set: images}
            });
            createdObject = update(createdObject, {
                meta: {$set: meta}
            });
            return {...state, createdObject: createdObject};
        case ActionTypes.UPDATE_MAIN_PHOTO_URL:
            return {...state, mainPhotoURL: action.payload};
        case ActionTypes.UPDATE_PHOTO_ORDERS:
            return {
                ...state,
                createdObject: {...state.createdObject, meta: {...state.createdObject.meta, images: action.payload}}
            };
        case ActionTypes.CREATING_PROPERTY_CHANGE_CALENDAR_LOADING:
            return {...state, isShowCalendarLoading: action.payload};
        case ActionTypes.CREATING_PROPERTY_SET_CURRENT_DAYS:
            return {
                ...state,
                currentDays: action.payload.currentDays,
                currentDaysCurrency: action.payload.currency,
                isShowCalendarLoading: false
            };
        case ActionTypes.CREATING_PROPERTY_UPDATE_DAYS:
            currentDays = state.currentDays;

            action.payload.forEach(elem => {
                if (elem !== undefined) {
                    index = currentDays.findIndex(item => item.date === elem.date);

                    if (index !== -1) {
                        let blocked = currentDays[index].blocked;
                        let bookingId = currentDays[index].bookingId;
                        let externalCalendarName = currentDays[index].externalCalendarName;

                        if (bookingId === null && externalCalendarName === null) {
                            blocked = elem.blocked !== undefined ? elem.blocked : currentDays[index].blocked;
                        }

                        const day = update(
                            currentDays[index], {
                                price: {$set: elem.price !== undefined ? elem.price : currentDays[index].price},
                                blocked: {$set: blocked},
                                minNights: {$set: elem.minNights !== undefined ? elem.minNights : currentDays[index].minNights},
                            });

                        currentDays = update(currentDays, {
                            $splice: [[index, 1, day]]
                        });
                    }
                }
            });
            return {...state, currentDays: currentDays};
        case ActionTypes.SET_GENERAL_INFORMATION_VALID:
            validation = update(state.validation, {
                isGeneralInformationValid: {$set: action.payload}
            });
            return {...state, validation: validation};
        case ActionTypes.SET_ADDRESS_VALID:
            validation = update(state.validation, {
                isAddressValid: {$set: action.payload}
            });
            return {...state, validation: validation};
        case ActionTypes.SET_REDIRECT_TO_OBJECT_PAGE:
            return {...state, isRedirectToObjectPage: action.payload};
        case ActionTypes.ADD_EXTERNAL_CALENDAR:
            createdObject = state.createdObject;
            externalCalendars = createdObject.meta.externalCalendars;

            if (externalCalendars == null) {
                externalCalendars = [action.payload];
                meta = update(createdObject.meta, {
                    externalCalendars: {$set: externalCalendars}
                });
            } else {
                meta = update(createdObject.meta, {
                    externalCalendars: {$push: [action.payload]}
                });
            }
            createdObject = update(createdObject, {
                meta: {$set: meta}
            });
            return {...state, createdObject: createdObject};
        case ActionTypes.DELETE_EXTERNAL_CALENDAR:
            createdObject = state.createdObject;
            index = createdObject.meta.externalCalendars.findIndex(elem => elem.id === action.payload);

            externalCalendars = update(createdObject.meta.externalCalendars, {
                $splice: [[index, 1]]
            });
            meta = update(createdObject.meta, {
                externalCalendars: {$set: externalCalendars}
            });
            createdObject = update(createdObject, {
                meta: {$set: meta}
            });
            return {...state, createdObject: createdObject};
        case ActionTypes.SET_IS_SHOW_PROGRESS_BAR:
            return {...state, isShowProgressBar: action.payload};
        case ActionTypes.SET_EXPORT_VALUE:
            createdObject = state.createdObject;

            _export = update(createdObject.meta.export, {
                [action.exportField]: {$set: action.payload}
            });

            meta = update(createdObject.meta, {
                export: {$set: _export}
            });
            createdObject = update(createdObject, {
                meta: {$set: meta}
            });
            return {...state, createdObject: createdObject};
        case ActionTypes.SET_PROGRESS_BAR_INFO:
            const progressBarInfo = update(state.progressBarInfo, {
                loaded: {$set: action.payload.loaded},
                total: {$set: action.payload.total}
            });
            return {...state, progressBarInfo: progressBarInfo};
        case ActionTypes.SET_PRICES_VALID:
            validation = update(state.validation, {
                isPricesValid: {$set: action.payload}
            });
            return {...state, validation: validation};
        case ActionTypes.SET_OTHER_VALID:
            validation = update(state.validation, {
                isOtherValid: {$set: action.payload}
            });
            return {...state, validation: validation};
        case ActionTypes.SET_NEED_CREATE_OBJECT:
            return {...state, isNeedCreateObject: action.isNeedCreateObject};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/CreatingObjectPage.js